import { render } from "./FoldableContainer.vue?vue&type=template&id=70855426"
import script from "./FoldableContainer.vue?vue&type=script&lang=js"
export * from "./FoldableContainer.vue?vue&type=script&lang=js"

import "./FoldableContainer.vue?vue&type=style&index=0&id=70855426&lang=scss"

import exportComponent from "/home/runner/work/MMXD_CardOptimizer/MMXD_CardOptimizer/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__